import { Group, Stack, Text, Title } from '@mantine/core';
import type { ContextModalProps } from '@mantine/modals';

import { IconTrash } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { Button } from '../UI/Button/Button';

type DeleteModalProps = {
  onDelete: () => void;
};

export const DeleteModal = ({
  context,
  id,
  innerProps,
}: ContextModalProps<DeleteModalProps>) => {
  const { t } = useTranslation('shared');
  const { onDelete } = innerProps;

  return (
    <Stack p="04" spacing="00">
      <Title order={5}>{t('modals.deleteConfirmationModal.title')}</Title>
      <Text variant="sm" fw="400" c="gray.6" sx={{ whiteSpace: 'pre-line' }}>
        {t('modals.deleteConfirmationModal.description')}
      </Text>
      <Group position="right" mt="04">
        <Button
          variant="subtle"
          color="dark"
          onClick={() => context.closeModal(id)}
        >
          {t('modals.deleteConfirmationModal.cancel')}
        </Button>
        <Button
          onClick={() => {
            onDelete();
            context.closeModal(id);
          }}
          leftIcon={<IconTrash size={18} />}
          size="md"
          color="red"
        >
          {t('modals.deleteConfirmationModal.delete')}
        </Button>
      </Group>
    </Stack>
  );
};
